import PropTypes from 'prop-types';
import React from 'react';
import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import HeartNew from 'yoda-core-components/lib/assets/svg/Heartfill.svg';
import HeartFillGrey from 'yoda-core-components/lib/assets/svg/HeartFillGrey.svg';
import DropdownArrow from 'yoda-core-components/lib/assets/icons/navigation/triangle-down.svg';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';

function SelectedList({ listName, listId, clickHandler, isShared, children, deviceType }) {
    const icon =
        listId === 'myFavorites' || listName === 'My Favorites' ? <HeartNew /> : <HeartFillGrey />;
    const buttonProps = { onClick: clickHandler };
    let listNameDisplay = listName;
    if (deviceType && deviceType.isMobile && listName && listName.length > 18) {
        listNameDisplay = `${listName.substring(0, 18)} ...`;
    }
    return (
        <div className={dt(['smOnly:mb-4', 'relative', 'flex', 'items-center'])}>
            <div className={dt(['inline-block', 'mr-2'])}>
                <Icon
                    viewBox="0 0 36 36"
                    iconType="svg"
                    className={dt([
                        listId === 'myFavorites' && '-mt-1.5',
                        listId !== 'myFavorites' && '-mt-2.5',
                    ])}
                    height="36px"
                    width="36px"
                >
                    {icon}
                </Icon>
            </div>
            <div
                className={dt(['flex', 'items-center'])}
                {...buttonProps}
                data-automation-id="list-names-dropdown"
            >
                {!isShared && (
                    /* eslint-disable react/jsx-props-no-spreading */
                    <div className={dt(['!text-justify'])}>
                        <div
                            className={dt([
                                'inline-block',
                                'mr-1',
                                'font-open-sans-bold',
                                'cursor-pointer',
                                'text-xlarge',
                            ])}
                        >
                            List:
                        </div>
                        <div
                            className={dt([
                                'inline-block',
                                'mr-2',
                                'font-open-sans-regular',
                                'text-xlarge',
                                'text-black',
                                'cursor-pointer',
                                'text-left',
                            ])}
                            dangerouslySetInnerHTML={{ __html: listNameDisplay }}
                        />
                    </div>
                )}
                {isShared && (
                    /* eslint-disable react/jsx-props-no-spreading */
                    <div>
                        <div
                            className={dt([
                                'inline-block',
                                'mr-1',
                                'font-open-sans-bold',
                                'cursor-default',
                            ])}
                        >
                            Shared List:
                        </div>
                        <div
                            className={dt([
                                'inline-block',
                                'mr-1',
                                'font-open-sans-regular',
                                'not-italic',
                                'text-xLg',
                                'text-black',
                                'cursor-default',
                            ])}
                            dangerouslySetInnerHTML={{ __html: listNameDisplay }}
                        />
                    </div>
                )}
                {!isShared && (
                    /* eslint-disable react/jsx-props-no-spreading */
                    <div className={dt(['inline-block', 'mr-1', 'relative', 'cursor-pointer'])}>
                        <Icon iconType="svg" width="16px" height="16px" viewBox="0 0 16 16">
                            <DropdownArrow />
                        </Icon>
                    </div>
                )}
            </div>
            {children}
        </div>
    );
}

SelectedList.defaultProps = {
    children: undefined,
};

SelectedList.propTypes = {
    listId: PropTypes.string.isRequired,
    listName: PropTypes.string.isRequired,
    clickHandler: PropTypes.func.isRequired,
    isShared: PropTypes.bool.isRequired,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default SelectedList;
